import { useEffect, useState } from 'react';

interface TocItem {
  id: string;
  text: string;
}

interface ArticleTocProps {
  items: TocItem[];
}

export default function ArticleToc({ items }: ArticleTocProps) {
  const [activeId, setActiveId] = useState(items[0]?.id || '');

  useEffect(() => {
    const observers: IntersectionObserver[] = [];
    items.forEach((item) => {
      const el = document.getElementById(item.id);
      if (!el) return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) setActiveId(item.id);
          });
        },
        { rootMargin: '-120px 0px -65% 0px', threshold: 0 },
      );
      observer.observe(el);
      observers.push(observer);
    });
    return () => observers.forEach((observer) => observer.disconnect());
  }, [items]);

  if (items.length === 0) return null;

  return (
    <nav aria-label="文章目录" className="rounded-lg border border-background-200 bg-background-100 p-5">
      <h2 className="flex items-center gap-2 border-b border-background-200 pb-3 font-heading text-base font-bold text-foreground-950">
        <i className="ri-list-check-2 text-lg text-primary-500" aria-hidden="true"></i>
        本文目录
      </h2>
      <ul className="mt-3 space-y-1">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={`block rounded-md border-l-2 px-3 py-1.5 text-sm transition-colors ${
                activeId === item.id
                  ? 'border-primary-500 bg-background-50 font-medium text-primary-600'
                  : 'border-transparent text-foreground-600 hover:text-foreground-950'
              }`}
            >
              {item.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}